import { AgencyType } from "../../../types/agencyTypes";

export const SET_AGENCY = "SET_AGENCY";
type SET_AGENCY = typeof SET_AGENCY;

export const SET_ADVERTISERS = "SET_ADVERTISERS";
type SET_ADVERTISERS = typeof SET_ADVERTISERS;

export const SET_PLAYBOOKS = "SET_PLAYBOOKS";
type SET_PLAYBOOKS = typeof SET_PLAYBOOKS;

export const SET_SELECTED_ADVERTISER = "SET_SELECTED_ADVERTISER";
type SET_SELECTED_ADVERTISER = typeof SET_SELECTED_ADVERTISER;

export type SetUpdatedAgencyAction = {
  type: SET_AGENCY;
  payload: AgencyType;
};
